import { faker } from '@faker-js/faker';
import { Factory } from 'miragejs';

export default Factory.extend({
  name() {
    return faker.company.name();
  },

  text() {
    return faker.lorem.paragraph();
  },

  cmsLanguageId() {
    return String(
      faker.datatype.number({
        min: 1,
        max: 2,
      }),
    );
  },

  cmsState() {
    return faker.datatype.number({
      min: 1,
      max: 3,
    });
  },

  cmsCreated() {
    return faker.date.past();
  },

  cmsModified() {
    return faker.date.past();
  },

  afterCreate(label, server) {
    label.update({
      asset: server.create('asset'),
      channels: server.createList('channel', 2),
      externalReferences: server.createList('external-reference', 4),
    });
  },
});
